/**
 * @version:               1.0.0
 * @createTime:            2021.10.09
 * @updateTime:            2021.10.09
 * @author:                zhangju
 * @description
 ***/
export default {
    name: 'fdFooter',
    data() {
        return {};
    }
};
